<template>
  <div>
    <div class="l-row">
      <form-group :label="$t('product.reduced.label')" :columns="6">
        <select v-model="options.product.reduced" class="form-select">
          <option :value="false">Não</option>
          <option :value="true">Sim</option>
        </select>
        <small class="form-help">Caso essa opção seja definida como "sim" o arquivo de csv irá retornar apenas os seguintes campos:<br>
          - Sku
          <br>- Ean
          <br>- Preço de
          <br>- Preço por
        </small>
      </form-group>
    </div>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      options: {
        product: {
          reduced: false
        }
      },
      disabled: true,
      source: {}
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      getOptions () {
        return this.options
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .form-checkbox
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// Options.vue?4ba89374